<ng-container *ngIf="(pageLoading$ | async) === false; else loading">
  <div class="order-submitted-container">
    <ng-container *ngIf="(showFulfillmentForm$ | async) === false">
      <mat-card appearance="outlined">
        <mat-card-content>
          <mat-icon class="checkbox-icon">task_alt</mat-icon>
          <h3>{{ 'COMMON.ORDER_SUBMITTED.ORDER_SUBMITTED' | translate }}</h3>
          <div class="inner-text">
            {{ 'COMMON.ORDER_SUBMITTED.RECEIVE_CONFIRMATION_SHORTLY' | translate }}
          </div>
          <div *ngIf="showFulfillmentForm$ | async" class="inner-text">
            {{ 'COMMON.ORDER_SUBMITTED.ITEM_HAS_FULFILLMENT_FORM' | translate }}
          </div>
          <div class="buttons-container">
            <button [routerLink]="accountDetailsUrl" mat-flat-button color="primary">
              {{ 'COMMON.ORDER_SUBMITTED.VIEW_ACCOUNT_DETAILS' | translate }}
            </button>
            <button [routerLink]="salesOrderUrl" mat-stroked-button>
              {{ 'COMMON.ORDER_SUBMITTED.VIEW_ORDER' | translate }}
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </div>
  <ng-container *ngIf="showFulfillmentForm$ | async">
    <div class="instant-fulfillment-form-container">
      <ng-container *ngIf="woFormDoneLoading$ | async; else loading">
        <div class="form-icon">
          <mat-icon>list_alt</mat-icon>
        </div>
        <div class="form-title">{{ 'COMMON.ORDER_SUBMITTED.FULFILLMENT_FORMS' | translate }}</div>
        <div class="form-subtitle">{{ 'COMMON.ORDER_SUBMITTED.FULFILLMENT_FORMS_SUBTITLE' | translate }}</div>
      </ng-container>
      <div *ngFor="let woInfo of workOrderFormInfos$ | async; let i = index" class="wo-form-container">
        <work-order-form
          [salesOrderId]="woInfo.salesOrderId"
          [appId]="woInfo.appId"
          [accountGroupId]="woInfo.businessId"
          [marketId]="woInfo?.businessInfo?.marketId"
          [resellerPartnerId]="woInfo.resellerPartnerId"
          [persona]="persona"
          [showOfficeUseQuestions]="true"
          [users]="users"
          (submitClicked)="handleFOFormSubmitClicked(woInfo.appId)"
          (doneLoading)="handleWOFormDoneLoading(i)"
        ></work-order-form>
      </div>
    </div>
    <div *ngIf="woFormDoneLoading$ | async" class="button-footer">
      <div class="footer-container">
        <a [routerLink]="accountDetailsUrl" data-action="order-submitted-back-to-account">
          <button mat-stroked-button>{{ 'COMMON.ORDER_SUBMITTED.BACK_TO_ACCOUNT' | translate }}</button>
        </a>
        <a [routerLink]="salesOrderUrl" data-action="order-submitted-view-order">
          <button mat-flat-button color="primary">{{ 'COMMON.ORDER_SUBMITTED.VIEW_ORDER' | translate }}</button>
        </a>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-template #loading>
  <div class="stencil-shimmer order-submitted-loading"></div>
</ng-template>
